import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { isExpired } from 'react-jwt';
import { loginHelper } from '../helpers/login.helper';
import LoginLayout from '../components/organisms/LoginLayout';
import { logActivity } from '../helpers/logActivity.helper';

const Login = () => {
  const [errorMsg, setErrorMsg] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    if (!isExpired(localStorage.getItem('token'))) {
      navigate('/manage');
    }
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    const token = await loginHelper(
      document.getElementById('username').value,
      document.getElementById('password').value
    );

    if (token) {
      logActivity('User logged in');
      localStorage.setItem('token', token);
      navigate('/manage');
    } else {
      setErrorMsg('Invalid Username / Password');
    }
  };

  const checkKeyStroke = e => {
    if (e.key === 'Enter') handleSubmit(e);
  };

  return (
    <LoginLayout
      handleSubmit={handleSubmit}
      checkKeyStroke={checkKeyStroke}
      errorMsg={errorMsg}
    />
  );
};

export default Login;
